module.exports = __webpack_public_path__ + "img/login.6bba62c3.jpg";